// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-app>
    <v-container fluid>
      <v-alert
        type="warning"
        dismissible
        :value="$route.query.error !== undefined">
        SSO error: {{ $route.query.error }}
      </v-alert>
      <v-row>
        <v-col cols="8" offset="2" lg="4" offset-lg="4" md="6" offset-md="3">
          <v-img
            v-bind:src="'static/logo.svg'"
            contain
            aspect-ratio="7.696"
            style="width:75%; background-color: white; margin-right:auto; margin-left:auto;"
            class="my-12"/>
          <v-card>
            <v-card-title>
              <span class="headline">Login</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
              label="Email"
              id="email"
              required
              v-model="credentials.username"
              v-on:keyup.enter="login()"
              ></v-text-field>
              <v-text-field
              label="Password"
              id="password"
              type="password"
              required
              v-model="credentials.password"
              v-on:keyup.enter="login()"
              ></v-text-field>
              <router-link :to="{name: 'passwordResetRequest'}">Forgot My Password</router-link>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="blue--text darken-1" text @click.native="login">Login</v-btn>
            </v-card-actions>
          </v-card>
          <v-card flat class="text-with-lines my-1" v-if="oktaAvailable || entraAvailable">
            <v-card-text class="text-content">
              OR
            </v-card-text>
          </v-card>
          <v-btn outlined
            block
            v-if="oktaAvailable"
            @click.native="oktaLogin"
          >
            <div style="height: 32px; width: 72px; margin-right: 48px;">
              <img src="static/okta.png" style="height: 100%; width: 100%; object-fit: contain;">
            </div>
            Login with Okta
          </v-btn>
          <v-btn outlined
            block
            style="margin-top: 12px;"
            v-if="entraAvailable"
            @click.native="entraLogin"
          >
            <div style="height: 36px; width: 72px; margin-right: 48px; padding-top: 6px;">
              <img src="static/entra.png" style="height: 80%; width: 100%; margin-top: auto; margin-bottom: auto; object-fit: contain;">
            </div>
            Login with Entra
          </v-btn>
        </v-col>
      </v-row>
    <error-snackbar v-model="errorText"></error-snackbar>
    </v-container>
  </v-app>
</template>

<style scoped>
.text-with-lines {
  position: relative;
}

.text-content {
  position: relative;
  text-align: center;
  padding: 10px 20px;
}

.text-with-lines::before,
.text-with-lines::after {
  content: '';
  position: absolute;
  top: 50%;
  height: 1px;
  background-color: rgba(128, 128, 128, 0.5);
}

.text-with-lines::before {
  left: 0;
  width: calc(50% - 20px);
}

.text-with-lines::after {
  right: 0;
  width: calc(50% - 20px);
}
</style>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'
import ApiRequests from '@/api/ApiRequests'

import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      oktaAvailable: false,
      entraAvailable: false,
      errorText: ''
    }
  },

  methods: {
    ...mapActions([
      'getUserData'
    ]),

    isOktaAvailable: function () {
      ApiRequests.oktaAvailable().then(_ => {
        this.oktaAvailable = true
      }).catch(_ => {
        this.oktaAvailable = false
      })
    },

    isEntraAvailable: function () {
      ApiRequests.entraAvailable().then(_ => {
        this.entraAvailable = true
      }).catch(_ => {
        this.entraAvailable = false
      })
    },

    oktaLogin: function () {
      window.location.href = '/auth/okta/redirect'
    },

    entraLogin: function () {
      window.location.href = '/auth/entra/redirect'
    },

    login: function () {
      var credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      }
      axios.post('/auth/login', credentials, {}).then(response => {
        var ref = this.$route.query.referer
        if (ref === undefined) {
          this.$router.push({name: 'items'})
          return
        }
        var split = ref.split('?')
        var path = ''
        if (split.length > 0) {
          path = split[0]
        }
        if (ref && path !== '' && !ref.includes('login')) {
          this.$router.push(ref)
        } else {
          this.$router.push({name: 'items'})
        }
        this.getUserData()
      }).catch(e => {
        if (e.response.data !== undefined && e.response.data.reason !== undefined) {
          if (e.response.data.reason === 'rate limited') {
            this.errorText = 'Too many recent failed logins: wait a minute and try again'
          } else if (e.response.data.reason === 'account locked') {
            this.errorText = 'Too many recent failed logins: use Forgot My Password to unlock your account'
          } else {
            this.errorText = 'Invalid username or password'
          }
        } else {
          this.errorText = 'Invalid username or password'
        }
      })
    }
  },

  mounted () {
    this.isOktaAvailable()
    this.isEntraAvailable()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue